import { createContext, useContext } from 'react';

export const VendorEntitlementsContext = createContext({
  features: {},
  limits: {},
  loading: true,
});

export const useVendorEntitlements = () => useContext(VendorEntitlementsContext);

/** "hidden" | "read_only" | "full" (defaults to "full" while entitlements
 * are still loading, so pages don't flash a disabled state). */
export function accessFor(features, key, loading) {
  if (loading) return 'full';
  return features?.[key] || 'hidden';
}

export const isReadOnly = (features, key, loading) => accessFor(features, key, loading) === 'read_only';
export const isHidden = (features, key, loading) => accessFor(features, key, loading) === 'hidden';
